module.exports = __webpack_public_path__ + "static/img/img_logo_1.19e46286.png";